import MobileUIWF1 from "./MobileUIWF1";

export default function TwoMobilesUI() {
  return (<>
    <div className="two-mobiles-wrapper">
      <div className="mobile-col" style={{transform:"scale(0.95)",right:"-40px"}}>
        <MobileUIWF1 cardType={2} />
      </div>

      <div className="mobile-col" >
        <MobileUIWF1 cardType={1} />
      </div>
    </div>
    <style>{`.two-mobiles-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 0px;
 
}

.mobile-col {position:relative;
  display: flex;
  justify-content: ;
}
                                 /* xs */
@media (max-width: 767px) {
.two-mobiles-wrapper{transform:scale(0.5);height:500px;margin-top:-160px;}
}

`}</style></>
  );
}